import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import {NavbarTab} from "@service/types/NavbarTab";
import {Route} from "vue-router";

const isProgramActive = (item: NavbarTab, route: Route): boolean => {
    return item.routes.indexOf(route.name as string) > -1
}

const isCatalogActive = (item: NavbarTab, route: Route): boolean => {
    return item.defaultParams.params.schemaId === route.params.schemaId;
}

const isInfoPageActive = (item: NavbarTab, route: Route): boolean => {
    return item.defaultParams.params.objectId === route.params.objectId;
}

const isAppointmentActive = (route: Route): boolean => {
    return ([RouteNamesEnum.meetingsSchedule, RouteNamesEnum.appointment] as string[]).includes(route.name || "")
}

const isCommitteesActive = (route: Route): boolean => {
    return ([RouteNamesEnum.committeesCreate, RouteNamesEnum.committeesEdit, RouteNamesEnum.committeesList, RouteNamesEnum.committeesView] as string[]).includes(route.name || "")
}

export { isProgramActive, isCatalogActive, isInfoPageActive, isAppointmentActive, isCommitteesActive }
